import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import SecuritySection from './SecuritySection'
import ProfileSection from './ProfileSection'

import {
  getUserId,
  getUserEmail,
  getUserName,
  getUserLastName,
  getSaving,
  getHasLoadedUserDataSuccessfully,
  getHasUpdatedProfileSuccessfully,
  getErrorMessageCurrentPasswordForNewEmail,
  getErrorMessageCurrentPasswordForNewPassword,
  getUploadingAvatar,
  getUserAvatarUrl,
} from '@SiteModules/User/selectors'

import {
  logout,
  updateProfile,
  changeAvatar,
  setUploadingAvatar,
} from '@SiteModules/User/actions'

import './UserProfile.scss'

const UserProfile: React.FC = () => {
  const dispatch = useDispatch()

  const userId = useSelector(getUserId)
  const userName = useSelector(getUserName)
  const userLastName = useSelector(getUserLastName)
  const userEmail = useSelector(getUserEmail)
  const hasLoadedSuccessfully = useSelector(getHasLoadedUserDataSuccessfully)
  const saving = useSelector(getSaving)
  const hasUpdatedProfileSuccessfully = useSelector(getHasUpdatedProfileSuccessfully)
  const uploadingAvatar = useSelector(getUploadingAvatar)
  const userAvatarUrl = useSelector(getUserAvatarUrl)
  const errorMessageCurrentPasswordForNewEmailFromBackend = useSelector(getErrorMessageCurrentPasswordForNewEmail)
  const errorMessageCurrentPasswordForNewPasswordFromBackend = useSelector(getErrorMessageCurrentPasswordForNewPassword)

  const handleLogout = () => {
    dispatch(logout({ forwardingUrl: '/users/sign_in' }))
  }

  const handleSaveEditedProfile = (name: string, lastName: string) => {
    dispatch(updateProfile({ name, lastName, userId }))
  }

  const handleSaveEditedEmail = (email: string, currentPassword: string) => {
    dispatch(updateProfile({ email, currentPassword, userId }))
  }

  const handleSaveEditedPassword = (password: string, currentPassword: string) => {
    dispatch(updateProfile({ password, currentPassword, userId }))
  }

  const handleChangeAvatar = (url: string) => {
    dispatch(changeAvatar({ url, userId }))
  }

  const handleSetUploadingAvatar = () => {
    dispatch(setUploadingAvatar())
  }

  return (
    <div className="UserProfile">
      <ProfileSection
        userId={userId}
        userName={userName}
        userLastName={userLastName}
        userEmail={userEmail}
        hasLoadedSuccessfully={hasLoadedSuccessfully}
        hasUpdatedProfileSuccessfully={hasUpdatedProfileSuccessfully}
        saving={saving}
        handleSaveEditedProfile={handleSaveEditedProfile}
        userAvatarUrl={userAvatarUrl}
        uploadingAvatar={uploadingAvatar}
        changeAvatar={handleChangeAvatar}
        setUploadingAvatar={handleSetUploadingAvatar}
      />
      <SecuritySection
        userEmail={userEmail}
        handleLogout={handleLogout}
        saving={saving}
        hasUpdatedProfileSuccessfully={hasUpdatedProfileSuccessfully}
        handleSaveEditedEmail={handleSaveEditedEmail}
        handleSaveEditedPassword={handleSaveEditedPassword}
        errorMessageCurrentPasswordForNewEmailFromBackend={errorMessageCurrentPasswordForNewEmailFromBackend}
        errorMessageCurrentPasswordForNewPasswordFromBackend={errorMessageCurrentPasswordForNewPasswordFromBackend}
      />
    </div>
  )
}

export default UserProfile
